import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import pengajuanTagihanService from "../../services/pengajuanTagihanService";
import Cookies from "js-cookie";

export const initialState = {
    loading_pengajuan_tagihan: false,
    data_pengajuan_tagihan: [],
    showMessage:false,
    message:'',
}


export const getDataPengajuanTagihan = createAsyncThunk('pengajuan_tagihan/data',async (data, { rejectWithValue }) => {
    try {
        const response = await pengajuanTagihanService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const pengajuanTagihanSlice = createSlice({
    name: 'pengajuan_tagihan',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_pengajuan_tagihan = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPengajuanTagihan.fulfilled, (state, action) => {
                state.loading_pengajuan_tagihan = false
                state.data_pengajuan_tagihan = action.payload??[]
            })
            .addCase(getDataPengajuanTagihan.pending, (state) => {
                state.loading_pengajuan_tagihan = true
            })
            .addCase(getDataPengajuanTagihan.rejected, (state, action) => {
                state.loading_pengajuan_tagihan = false
                state.data_pengajuan_tagihan = action.payload
            })
    },
})

export const {
    showLoading,
} = pengajuanTagihanSlice.actions

export default pengajuanTagihanSlice.reducer
